import { Avatar, List } from 'antd';
import React from 'react';
import classNames from 'classnames';
import styles from './NoticeList.less';
const NoticeList = ({ list = [], onClick, onClear, title, onViewMore, emptyText, showClear = true, clearText, viewMoreText, showViewMore = false, }) => {
    if (!list || list.length === 0) {
        return (React.createElement("div", { className: styles.notFound },
            React.createElement("img", { src: "https://gw.alipayobjects.com/zos/rmsportal/sAuJeJzSKbUmHfBQRzmZ.svg", alt: "not found" }),
            React.createElement("div", null, emptyText)));
    }
    return (React.createElement("div", null,
        React.createElement(List, { className: styles.list, dataSource: list, renderItem: (item, i) => {
                const itemCls = classNames(styles.item, {
                    [styles.read]: item.read,
                });
                // eslint-disable-next-line no-nested-ternary
                const leftIcon = item.avatar ? (typeof item.avatar === 'string' ? (React.createElement(Avatar, { className: styles.avatar, src: item.avatar })) : (React.createElement("span", { className: styles.iconElement }, item.avatar))) : null;
                return (React.createElement(List.Item, { className: itemCls, key: item.id || i, onClick: () => onClick && onClick(item) },
                    React.createElement(List.Item.Meta, { className: styles.meta, avatar: leftIcon, title: React.createElement("div", { className: styles.title },
                            item.title,
                            React.createElement("div", { className: styles.extra }, item.extra)), description: React.createElement("div", null,
                            React.createElement("div", { className: styles.description }, item.description),
                            React.createElement("div", { className: styles.datetime }, item.datetime)) })));
            } }),
        React.createElement("div", { className: styles.bottomBar },
            showClear ? (React.createElement("div", { onClick: onClear },
                clearText,
                " ",
                title)) : null,
            showViewMore ? (React.createElement("div", { onClick: (e) => {
                    if (onViewMore) {
                        onViewMore(e);
                    }
                } }, viewMoreText)) : null)));
};
export default NoticeList;
